import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { Customer } from "../../types/customerTypes";
import { getDateAtTimeFormatString } from "../../utilities/date";
import formatPhoneNumber from "../../utilities/phone";
import { getActualLink } from "../../utilities/storeName";

type Props = {
  customer: Customer;
  handleChange: (e: any) => void;
  isEditing: boolean;
  errors?: any;
};

const CustomerForm: React.FC<Props> = ({ customer, handleChange, isEditing, errors }) => (
  <form>
    <Row>
      <Col>
        <Form.Group controlId="customer-name">
          <Form.Label className="small font-weight-bold">Customer</Form.Label>
          <Form.Control
            name="name"
            disabled={!isEditing}
            as="input"
            value={customer.name}
            onChange={handleChange}
            type="text"
            className={`bg-white ${isEditing ? "border border-secondary" : "border-0 p-0"} form-control`}
          />
          {errors.name && <p className="error text-danger">{errors.name}</p>}
        </Form.Group>
      </Col>
      <Col>
        <Form.Group controlId="customer-id">
          <Form.Label className="small font-weight-bold">Customer ID</Form.Label>
          <Form.Control
            name="id"
            as="input"
            type="text"
            value={customer.id}
            disabled
            className="bg-white border-0 p-0 form-control"
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group controlId="customer-shopify-id">
          <Form.Label className="small font-weight-bold">Shopify Customer ID</Form.Label>
          {isEditing ? (
            <Form.Control
              name="shopifyId"
              as="input"
              disabled={!isEditing}
              value={customer.shopifyId}
              onChange={handleChange}
              type="text"
              className={`bg-white ${isEditing ? "border border-secondary" : "border-0 p-0"} form-control`}
            />
          ) : (
            <a
              href={getActualLink(customer.countryCode, customer.shopifyId, "customers")}
              target="_blank"
              rel="noreferrer"
              className="form-control bg-white border-0 p-0 btn-link"
            >
              {customer.shopifyId}
            </a>
          )}
          {errors.shopifyId && <p className="error text-danger">{errors.shopifyId}</p>}
        </Form.Group>
      </Col>
    </Row>
    <Row>
      <Col>
        <Form.Group controlId="customer-email">
          <Form.Label className="small font-weight-bold">Email</Form.Label>
          <Form.Control
            name="email"
            as="input"
            disabled={!isEditing}
            value={customer.email}
            onChange={handleChange}
            type="text"
            className={`bg-white ${isEditing ? "border border-secondary" : "border-0 p-0"} form-control`}
          />
          {errors.email && <p className="error text-danger">{errors.email}</p>}
        </Form.Group>
      </Col>
      <Col>
        <Form.Group controlId="customer-phone">
          <Form.Label className="small font-weight-bold">Phone</Form.Label>
          <Form.Control
            name="phone"
            as="input"
            disabled={!isEditing}
            value={!isEditing ? formatPhoneNumber(customer.phone) : customer.phone}
            onChange={handleChange}
            type="text"
            className={`bg-white ${isEditing ? "border border-secondary" : "border-0 p-0"} form-control`}
          />
          {errors.phone && <p className="error text-danger">{errors.phone}</p>}
        </Form.Group>
      </Col>
      <Col>
        <Form.Group controlId="customer-joined">
          <Form.Label className="small font-weight-bold">Joined</Form.Label>
          <Form.Control
            name="createdAt"
            as="input"
            type="text"
            value={getDateAtTimeFormatString(customer.createdAt)}
            disabled
            className="bg-white border-0 p-0 form-control"
          />
        </Form.Group>
      </Col>
    </Row>
  </form>
);

export default CustomerForm;
